<form (ngSubmit)="save()">
  <mat-form-field appearance="outline">
    <mat-label>Адрес</mat-label>
    <input matInput type="text" [formControl]="cellControl" />
  </mat-form-field>
  <button mat-flat-button type="submit" color="primary">Сохранить</button>
</form>
